export default "skymp5-front/89f6ab9262055783f778ece7b2f4d836.png";